import { fetchFAQ } from "../../services/faq";
import { routes } from "../../helpers/router.helper";
import { IRequestCachingOptions } from "../../services/types";
import { ILink } from "./SubCategoryList.types";

interface IBoldConfig {
  host: string;
  account: string;
  kb: string;
}

export interface IFetchFAQLinks {
  config: IBoldConfig;
  labelId: string;
  categorySlug: string;
  subcategorySlug: string;
  customerContext?: string;
  visitorToken?: string;
}

export const fetchFAQLinks = async (
  params: IFetchFAQLinks,
  options?: IRequestCachingOptions
): Promise<ILink[]> => {
  const {
    config,
    labelId,
    categorySlug,
    subcategorySlug,
    customerContext,
    visitorToken,
  } = params;
  const boldContext = customerContext
    ? btoa(`customer:${customerContext}`)
    : undefined;

  const response = await fetchFAQ(
    {
      host: config.host,
      account: config.account,
      kb: config.kb,
      labelId: Number(labelId).toString(16),
      context: boldContext,
      visitorToken,
    },
    options
  );

  if (!response) {
    throw Error("Empty response");
  }

  const links: ILink[] = response.map((article) => ({
    title: article.label,
    route: routes.article(
      categorySlug,
      subcategorySlug,
      article.objectId,
      article.label
    ),
  }));

  return links;
};
